import { UserRoles } from '@/const/UserRoles'

export class SideMenuSettings {
  // 生徒CBTページのリンク設定
  static readonly STUDY_SELECTION: LinkSetting = {
    name: 'StudySelection',
    text: 'CBT',
    iconActive: 'dummy01.png',
    iconInactive: 'dummy02.png',
  }
  // 生徒結果ページのリンク設定
  static readonly STUDY_RESULT: LinkSetting = {
    name: 'StudyResult',
    text: '結果を見る',
    iconActive: 'dummy01.png',
    iconInactive: 'dummy02.png',
  }
  // 生徒空欄設定
  static readonly EMPTY: LinkSetting = {
    name: 'empty',
  }
  // 管理者塾管理ページのリンク設定
  static readonly MANAGER_ACADEMY: LinkSetting = {
    name: 'AcademyManagement',
    text: '塾・教室管理',
    icon: 'manager/sidemenu/academy.svg',
  }
  // 管理者テスト管理ページのリンク設定
  static readonly MANAGER_STUDY: LinkSetting = {
    name: 'StudyManagement',
    text: 'テスト管理',
    icon: 'manager/sidemenu/study.svg',
  }
  // 管理者ユーザー管理ページのリンク設定
  static readonly MANAGER_USER: LinkSetting = {
    name: 'TeacherManagement',
    text: 'ユーザー管理',
    icon: 'manager/sidemenu/user.svg',
  }
  // 管理者ユーザー管理ページのリンク設定（教室権限）
  static readonly BRANCH_MANAGER_USER: LinkSetting = {
    name: 'StudentManagement',
    text: 'ユーザー管理',
    icon: 'manager/sidemenu/user.svg',
  }
  // 管理者履歴管理ページのリンク設定
  static readonly MANAGER_HISTORY: LinkSetting = {
    name: 'HistoryStudyResultManagement',
    text: '履歴管理',
    icon: 'manager/sidemenu/history.svg',
  }
  // 管理者お知らせ管理ページのリンク設定
  static readonly MANAGER_NOTIFICATION: LinkSetting = {
    name: 'NotificationManagement',
    text: 'お知らせ管理',
    icon: 'manager/sidemenu/notification.svg',
  }
  // 管理者バッチ更新ページのリンク設定
  static readonly MANAGER_BATCH: LinkSetting = {
    name: 'BatchUpdate',
    text: 'バッチ更新',
    icon: 'manager/sidemenu/study.svg',
  }

  // 生徒のサイドメニュー設定
  static readonly STUDENT_SIDE_MENU: LinkSetting[] = [
    SideMenuSettings.STUDY_SELECTION,
    SideMenuSettings.EMPTY,
    SideMenuSettings.STUDY_RESULT,
  ]

  // システム管理者のサイドメニュー設定
  static readonly ADMIN_SIDE_MENU: LinkSetting[] = [
    SideMenuSettings.MANAGER_ACADEMY,
    SideMenuSettings.MANAGER_STUDY,
    SideMenuSettings.MANAGER_USER,
    SideMenuSettings.MANAGER_NOTIFICATION,
    SideMenuSettings.MANAGER_BATCH,
  ]

  // 塾管理者のサイドメニュー設定
  static readonly ACADEMY_SIDE_MENU: LinkSetting[] = [
    SideMenuSettings.MANAGER_STUDY,
    SideMenuSettings.MANAGER_USER,
    SideMenuSettings.MANAGER_HISTORY,
  ]

  // 教室長・講師のサイドメニュー設定
  static readonly BRANCH_SIDE_MENU: LinkSetting[] = [
    SideMenuSettings.MANAGER_STUDY,
    SideMenuSettings.BRANCH_MANAGER_USER,
    SideMenuSettings.MANAGER_HISTORY,
  ]

  // 管理者の設定
  static readonly ADMIN_SETTING: SideMenuSetting = {
    role: UserRoles.ADMIN,
    userNameSuffix: ' さん',
    links: SideMenuSettings.ADMIN_SIDE_MENU,
  }
  // 塾管理者の設定
  static readonly ACADEMY_SETTING: SideMenuSetting = {
    role: UserRoles.ACADEMY,
    userNameSuffix: ' さん',
    links: SideMenuSettings.ACADEMY_SIDE_MENU,
  }
  // 教室長・講師の設定
  static readonly BRANCH_SETTING: SideMenuSetting = {
    role: UserRoles.BRANCH,
    userNameSuffix: ' さん',
    links: SideMenuSettings.BRANCH_SIDE_MENU,
  }

  // 設定一覧
  static readonly LIST = [
    SideMenuSettings.ADMIN_SETTING,
    SideMenuSettings.ACADEMY_SETTING,
    SideMenuSettings.BRANCH_SETTING,
  ]

  // 権限で取得
  static findByRole(role: UserRoles): SideMenuSetting | undefined {
    return SideMenuSettings.LIST.find((setting) => {
      return setting.role === role
    })
  }
}

export type LinkSetting = {
  // リンク名（ルーティングで設定したnameの権限毎の接頭辞以外を指定）
  name: string
  // リンクテキスト
  text?: string
  // 活性アイコン画像パス
  iconActive?: string
  // 非活性アイコン画像パス
  iconInactive?: string
  // アイコン画像パス（非活性差分不要）
  icon?: string
}

export type SideMenuSetting = {
  // 権限
  role: UserRoles
  // ユーザ名接尾語
  userNameSuffix: string
  // リンク設定
  links: LinkSetting[]
}
